import { render, staticRenderFns } from "./AutoAssign.vue?vue&type=template&id=a407fa58&lang=pug"
import script from "./AutoAssign.vue?vue&type=script&lang=js"
export * from "./AutoAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports